import { defineMessages, MessageDescriptor } from 'react-intl';

const messages: Record<string, MessageDescriptor> = defineMessages({
	channels: {
		id: 'sidebar.channels',
		defaultMessage: 'Channels'
	},
	games: {
		id: 'sidebar.games',
		defaultMessage: 'Games'
	},
	audit: {
		id: 'sidebar.audit',
		defaultMessage: 'Audit'
	},
	dailyTests: {
		id: 'sidebar.dailyTests',
		defaultMessage: 'Daily Testing'
	},
	football: {
		id: 'sidebar.football',
		defaultMessage: 'Football'
	},
	golf: {
		id: 'sidebar.golf',
		defaultMessage: 'Golf'
	},
	f1: {
		id: 'sidebar.f1',
		defaultMessage: 'F1'
	},
	americanfootball: {
		id: 'sidebar.americanfootball',
		defaultMessage: 'US Football'
	},
	cricket: {
		id: 'sidebar.cricket',
		defaultMessage: 'Cricket'
	},
	baseball: {
		id: 'sidebar.baseball',
		defaultMessage: 'Baseball'
	},
	basketball: {
		id: 'sidebar.basketball',
		defaultMessage: 'Basketball'
	},
	recapSchedule: {
		id: 'sidebar.recapSchedule',
		defaultMessage: 'Schedules'
	},
	ukFootballSchedule: {
		id: 'sidebar.ukFootballSchedule',
		defaultMessage: 'UK Football'
	},
	germanFootballSchedule: {
		id: 'sidebar.germanFootballSchedule',
		defaultMessage: 'German Football'
	},
	italianFootballSchedule: {
		id: 'sidebar.italianFootballSchedule',
		defaultMessage: 'Italian Football'
	},
	f1Schedule: {
		id: 'sidebar.f1Schedule',
		defaultMessage: 'F1'
	},
	cricketSchedule: {
		id: 'sidebar.cricketSchedule',
		defaultMessage: 'Cricket'
	},
	peacockLemFeed: {
		id: 'sidebar.peacockLemFeed',
		defaultMessage: 'LEM Feed'
	},
	apiDocs: {
		id: 'sidebar.apiDocs',
		defaultMessage: 'API Docs'
	},
	skyApi: {
		id: 'sidebar.skyApi',
		defaultMessage: 'Sky UDM MW'
	},
	peacockApi: {
		id: 'sidebar.peacockApi',
		defaultMessage: 'Peacock MW'
	},
	wowApi: {
		id: 'sidebar.wowApi',
		defaultMessage: 'WOW MW'
	}
});

export default messages;
